import React from 'react';
import CTA from '@molecules/CTA';
import Tabs from '@molecules/Tabs';
import SearchMembersLikeMe from '../../../../icsc-app/js/components/searches/SearchMembersLikeMe';
import SearchSavedContacts from '../../../../icsc-app/js/components/searches/SearchSavedContacts';

const MemberContactsLists = () => (
    <Tabs defaultActiveTab="similar">
        <div tabKey="similar" title="Members Like Me">
            <div>
                <div className="mb-1rem">
                    <CTA
                        headerText="These ICSC members occupy roles similar to yours."
                        ctaText="See All Members Like Me"
                        ctaUrl="/my-icsc/connections/members-like-me"
                        ctaUrlIsInternal
                    />
                </div>

                <SearchMembersLikeMe defaultViewType="list" hitsPerPage={3} />
            </div>
        </div>

        <div tabKey="saved" title="Saved Contacts">
            <div>
                <div className="mb-1rem">
                    <CTA
                        headerText="These are the ICSC members you have saved."
                        ctaText="See All Saved Contacts"
                        ctaUrl="/my-icsc/connections/saved-contacts"
                        ctaUrlIsInternal
                    />
                </div>

                <SearchSavedContacts defaultViewType="list" hitsPerPage={3} />
            </div>
        </div>
    </Tabs>
);

MemberContactsLists.propTypes = {
    // members: PropTypes.array.isRequired,
};

export default MemberContactsLists;
